import React, { Component } from 'react';
import Select from "react-select";

class FormFilter extends Component {
    constructor(props){
        super(props)
        this.state = {

        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
    }

    render() {
        
        return (
            <React.Fragment>
                <div className="card mb-3">
                    <form onSubmit={this.handleSubmit}>
                        <div className="card-body">
                            <div className="row">

                                <div className="col-md-4 mb-3">
                                    <label>Nombre</label>
                                    <input
                                        type="text"
                                         name="name"
                                        value={this.props.formValues.name}
                                        onChange={this.props.onChangeForm}
                                        className={`form form-control`}
                                    />
                                </div>

                                    <div className="col-md-4 mb-3">
                                        <label>Fecha de vencimiento </label>
                                        <input
                                            type="date"
                                            name="due_date"
                                            value={this.props.formValues.due_date}
                                            onChange={this.props.onChangeForm}
                                            className={`form form-control`}
                                        />
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <input
                                            type="hidden"
                                            name="document_type_id"
                                            value={this.props.selectedOptionDocumentType.document_type_id}
                                        />                                                        
                                        <label>Tipo de documento </label>
                                        <Select
                                            onChange={this.props.handleChangeAutocompleteDocumentType}
                                            options={this.props.document_types}
                                            autoFocus={false}
                                            className={`link-form`}
                                            value={this.props.selectedOptionDocumentType}
                                        />
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <input
                                            type="hidden"
                                            name="proceso_id"
                                            value={this.props.selectedOptionProceso.proceso_id}
                                        />                                                        
                                        <label>Proceso </label>
                                        <Select
                                            onChange={this.props.handleChangeAutocompleteProceso}
                                            options={this.props.procesos}
                                            autoFocus={false}
                                            className={`link-form`}
                                            value={this.props.selectedOptionProceso}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label>Versión</label>
                                        <input
                                            type="number"
                                            name="version"
                                            value={this.props.formValues.version}
                                            onChange={this.props.onChangeForm}
                                            className={`form form-control`}
                                        />
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <input
                                            type="hidden"
                                            name="user_create_id"
                                            value={this.props.selectedOptionUserCreate.user_create_id}
                                        />                                                        
                                        <label>Usuario que crea </label>
                                        <Select
                                            onChange={this.props.handleChangeAutocompleteUserCreate}
                                            options={this.props.users}
                                            autoFocus={false}
                                            className={`link-form`}
                                            value={this.props.selectedOptionUserCreate}
                                        />
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <input
                                            type="hidden"
                                            name="user_review_id"
                                            value={this.props.selectedOptionUserReview.user_review_id}
                                        />                                                        
                                        <label>Usuario que revisa </label>
                                        <Select
                                            onChange={this.props.handleChangeAutocompleteUserReview}
                                            options={this.props.users}
                                            autoFocus={false}
                                            className={`link-form`}
                                            value={this.props.selectedOptionUserReview}
                                        />
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <input
                                            type="hidden"
                                            name="user_approve_id"
                                            value={this.props.selectedOptionUserApprove.user_approve_id}
                                        />                                                        
                                        <label>Usuario que aprueba </label>
                                        <Select
                                            onChange={this.props.handleChangeAutocompleteUserApprove}
                                            options={this.props.users}
                                            autoFocus={false}
                                            className={`link-form`}
                                            value={this.props.selectedOptionUserApprove}
                                        />
                                    </div>
                                
                            </div>
                        </div>

                        <div className="card-footer">
                            <button
                                className="btn-shadow btn btn-info mr-3"
                                onClick={() => this.props.HandleClickFilter()}
                            >
                                Aplicar Filtro
                            </button>

                            <a
                                className="btn btn-outline-danger"
                                onClick={() => this.props.filter(false)}
                            >
                                Cancelar
                            </a>

                        </div>
                    </form>
                </div>
            </React.Fragment>
        );
    }
}

export default FormFilter;